import { AxiosResponse } from "axios";
import { RestServiceConnection } from "../restServiceConnection";

const STOCKMOVEMENTS_ENDPOINT = "/stock-movements";

export class StockMovementService extends RestServiceConnection {

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA DE MOVIMIENTOS DE STOCK
     * @EN GETS THE LIST OF STOCK MOVEMENTS
     */
    // -------------------------------------------------------------------------------------------------------------
    listStockMovements = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: STOCKMOVEMENTS_ENDPOINT + "/list",
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE UN MOVIMIENTO DE STOCK POR SU ID
     * @EN GETS A STOCK MOVEMENT BY ITS ID
     */
    // -------------------------------------------------------------------------------------------------------------
    getStockMovementById = async (stockMovementId: string) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: STOCKMOVEMENTS_ENDPOINT + "/get",
            data: { id: stockMovementId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES CREA UN MOVIMIENTO DE STOCK
     * @EN CREATES A STOCK MOVEMENT
     */
    // -------------------------------------------------------------------------------------------------------------
    createStockMovement = async (stockMovement: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: STOCKMOVEMENTS_ENDPOINT + "/create",
            data: stockMovement,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES EDITA UN MOVIMIENTO DE STOCK
     * @EN EDITS A STOCK MOVEMENT
     */
    // -------------------------------------------------------------------------------------------------------------
    editStockMovement = async (stockMovement: any) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: STOCKMOVEMENTS_ENDPOINT + "/edit",
            data: stockMovement,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA UN MOVIMIENTO DE STOCK
     * @EN DELETES A STOCK MOVEMENT
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteStockMovement = async (stockMovementId: string) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: STOCKMOVEMENTS_ENDPOINT + "/delete",
            data: { id: stockMovementId },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA VARIOS MOVIMIENTOS DE STOCK
     * @EN DELETES MULTIPLE STOCK MOVEMENTS
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteMultiStockMovement = async (stockMovementIds: string[]) => {
        this.response = await this.makeRequest({
            method: "POST",
            url: STOCKMOVEMENTS_ENDPOINT + "/delete-multi",
            data: { 
                ids:stockMovementIds
            }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

}